import { useMemo } from 'react';

import {
	usePetitionDetailsPageData,
	usePetitionDetailsPageFcm,
	usePetitionDetailsPageUserData,
} from 'src/app/pages/petitionGamma/details/pageContext';

import { usePetitionStats } from '../../../hooks/petitionStats';

import type { MobileModalContext } from './types';

export function useMobileModalContext(): MobileModalContext {
	const pageData = usePetitionDetailsPageData();
	const pageUserData = usePetitionDetailsPageUserData();
	const stats = usePetitionStats();
	const fcm = usePetitionDetailsPageFcm();

	return useMemo(() => ({ pageData, pageUserData, stats, fcm }), [pageData, pageUserData, stats, fcm]);
}
